import { memo, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";
import { PlainSizeType } from "@/lib/gql/__generated__/graphql";

/**
 * Cover: ヒーロー（KV + ロゴ）
 *
 * ゲスト側 app/frontend/guest/plain/src/components/top/HeroSection.astro の逐語再現。
 * - section 高さ: mobile 190px / tablet 220px（theme token ベース）
 * - KV 画像: absolute inset-0 object-cover
 * - ロゴ: KV 中央（KV 有り時）、または下寄せ（KV 無し時）
 * - ロゴサイズ: Small/Medium/Large で 74/90/110px (mobile)、94/110/130px (tablet)
 */

type Props = {
	isShowHotelKeyVisual: boolean;
	isShowLogo: boolean;
	mainKeyVisualUrl: string;
	logoSize: PlainSizeType;
	logoUrl: string;
};

export const Cover = memo(({ isShowHotelKeyVisual, isShowLogo, mainKeyVisualUrl, logoSize, logoUrl }: Props) => {
	const canShowMainKeyVisual = useMemo(
		() => isShowHotelKeyVisual && mainKeyVisualUrl !== "",
		[ isShowHotelKeyVisual, mainKeyVisualUrl ],
	);
	const canShowLogo = useMemo(() => isShowLogo && logoUrl !== "", [ isShowLogo, logoUrl ]);

	const logoHeightClass = useMemo(() => {
		if (PlainSizeType.Small === logoSize) return "h-[74px] tablet:h-[94px]";
		if (PlainSizeType.Medium === logoSize) return "h-[90px] tablet:h-[110px]";
		return "h-[110px] tablet:h-[130px]";
	}, [ logoSize ]);

	return (
		<section className="relative h-[190px] w-full tablet:h-[220px]">
			{canShowMainKeyVisual && (
				<img
					src={mainKeyVisualUrl}
					alt=""
					width="1920"
					height="1080"
					loading="eager"
					className="absolute inset-0 size-full object-cover"
				/>
			)}
			{canShowLogo && (
				<div
					className={cn(
						"flex justify-center",
						canShowMainKeyVisual ? "absolute inset-0 items-center" : "h-full items-end pb-2",
					)}
				>
					<img src={logoUrl} alt="Logo" className={cn("w-auto object-contain", logoHeightClass)} />
				</div>
			)}
		</section>
	);
});
